"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkPreview = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../../theme");
const LinkPreview = ({ linkPreview }) => {
    const theme = theme_1.useSharedTheme();
    const imageUri = linkPreview && linkPreview.image_urls.square_small
        ? { uri: linkPreview.image_urls.square_small }
        : require('../../../../assets/no-image.png');
    return (react_1.default.createElement(react_native_1.View, { style: [styles.container, { backgroundColor: theme.colors.surface }] },
        react_1.default.createElement(react_native_1.Image, { source: imageUri, resizeMode: 'cover', style: styles.image }),
        react_1.default.createElement(react_native_1.View, { style: styles.textBlock },
            react_1.default.createElement(react_native_1.Text, { style: styles.title, numberOfLines: 1, ellipsizeMode: 'tail' }, linkPreview === null || linkPreview === void 0 ? void 0 : linkPreview.title),
            (linkPreview === null || linkPreview === void 0 ? void 0 : linkPreview.description) ? (react_1.default.createElement(react_native_1.Text, { style: styles.description, numberOfLines: 2, ellipsizeMode: 'tail' }, linkPreview === null || linkPreview === void 0 ? void 0 : linkPreview.description)) : null)));
};
exports.LinkPreview = LinkPreview;
const styles = react_native_1.StyleSheet.create({
    container: {
        flexDirection: 'row',
        width: '100%',
    },
    description: {
        fontFamily: theme_1.fontFamily,
        fontSize: 17,
    },
    image: {
        height: 80,
        width: 80,
    },
    textBlock: {
        flex: 1,
        justifyContent: 'center',
        margin: 8,
    },
    title: {
        fontFamily: theme_1.fontFamily,
        fontSize: 17,
        fontWeight: '500',
    },
});
